<template>
  <header>
    <div class="sub_header">
      <div class="logo_login">
        <v-btn v-if="isLogin" @click="activeMenu()" class="menu" icon>
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <v-btn class="btn_no_hover" text tile to="/">
          <img class="logo" alt src="../assets/img/logo_header.png" />
        </v-btn>
      </div>
      <div class="acount">
        <v-btn
          :ripple="false"
          v-if="isLogin"
          @click="signOut()"
          class="btn_logout"
          text
        >
          SALIR
          <v-icon small right>mdi-logout-variant</v-icon>
        </v-btn>
        <div v-if="getRolDevice === true" class="ctn_noty mr-1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :to="{ name: 'NotifyHome' }"
                class="btn_noty"
                v-if="isLogin"
                v-bind="attrs"
                v-on="on"
                icon
              >
                <div @click="actionNav('NotifyHome')" class="action_nav">
                  <div v-if="getNotify.check > 0" class="circle_noty">
                    <span>{{ getNotify.check }}</span>
                  </div>
                  <v-icon>mdi-bell</v-icon>
                </div>
              </v-btn>
            </template>
            <span>Alertas del sistema</span>
          </v-tooltip>
        </div>
        <!-- <p class="text_linea">linea de atención: 000000</p> -->
      </div>
    </div>
    <div class="box_menu_movil" :class="[evualuateMenu ? 'menu_active' : '']">
      <NavMovil v-bind="getRol" v-if="isLogin"></NavMovil>
    </div>
  </header>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import NavMovil from "@/components/NavMovil.vue";
export default {
  name: "Header",
  components: {
    NavMovil,
  },
  data() {
    return {
      menu: false,
    };
  },
  async mounted() {
    if (this.isLogin) {
      //await this.getJsonData();
      this.$root.$on("reload", async () => {
        await this.panelNotify();
      });
      await this.panelNotify();
    }
  },
  methods: {
    ...mapActions(["signOut", "actionNav", "panelNotify"]),
    ...mapMutations(["setBlackWindows"]),
    activeMenu() {
      if (this.menu === false) {
        this.menu = true;
        this.setBlackWindows(true);
      } else {
        this.menu = false;
        this.setBlackWindows(false);
      }
    },
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "getNotifyDeviceNumber",
      "getNotify",
      "getPanel",
      "getRolDevice",
      "getRol",
    ]),
    evualuateMenu() {
      return this.menu;
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/base";
button.menu {
  display: none;
  @media #{$phone-down} {
    display: block;
  }
}
p.text_linea {
  display: none;
  @media #{$tablet-up} {
    display: block;
  }
}
</style>
